module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-info"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "show-shortcut",
      "data-action": "toggleShortcut"
    }
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.userName) + "\n      ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-552bf1dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginInfo.vue
// module id = 1015
// module chunks = 1